module.exports = __webpack_public_path__ + "img/open_sided_and_detached_from_main_house_with_independent_roof.65081166.jpg";